import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../useAppDispatch';
import { resetDialog, setDialog } from '../../reducers/dialogReducer';
import OutcomeModal from '../../components/Modals/OutcomeModal';
import { Constants, OutcomeModalTypes } from '../../helpers/Constants';
import strings from '../../localization';

const useShowPaymentDialogs = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const goToBilling = () => {
    navigate(Constants.paths.pharmacyBilling);
    dispatch(resetDialog());
  };

  const showDisplayPackage = () => {
    dispatch(
      setDialog({
        Component: (
          <OutcomeModal
            type={OutcomeModalTypes.selectAPlan}
            message={strings.pleaseSelectAndAddCardDetails}
            customCloseLabel={strings.proceed}
            customClose={goToBilling}
            customTitleStyle={{ textAlign: 'center' }}
          />
        ),
        showCloseButton: true,
        heading: {
          title: '',
        },
      }),
    );
  };

  const actionRequiredDialog = () => {
    dispatch(
      setDialog({
        Component: (
          <OutcomeModal
            type={OutcomeModalTypes.selectPlanWarning}
            message={strings.youCannotPerformSelectPlan}
            customClose={goToBilling}
            customCloseLabel={strings.proceed}
          />
        ),
        showCloseButton: true,
        heading: {
          title: '',
        },
      }),
    );
  };

  return { showDisplayPackage, actionRequiredDialog };
};

export default useShowPaymentDialogs;
